import { render, staticRenderFns } from "./FacebookDeliveryTargetForm.vue?vue&type=template&id=4168af84&scoped=true&"
import script from "./FacebookDeliveryTargetForm.vue?vue&type=script&lang=js&"
export * from "./FacebookDeliveryTargetForm.vue?vue&type=script&lang=js&"
import style0 from "./FacebookDeliveryTargetForm.vue?vue&type=style&index=0&id=4168af84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168af84",
  null
  
)

export default component.exports